import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"tick\">\n<path d=\"M8,16C8,16,8,16,8,16c-0.3,0-0.6-0.1-0.8-0.4l-5-6C1.9,9.2,1.9,8.6,2.4,8.2c0.4-0.4,1.1-0.3,1.4,0.1l4.3,5.2\n\tl9.2-9.2c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-10,10C8.5,15.9,8.3,16,8,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol